<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <router-link
                tag="div"
                class="vx-logo cursor-pointer flex items-center"
                to="/"
              >
                <img
                  width="90%"
                  src="@/assets/images/logo/logo.png"
                  alt="login"
                  class="mx-auto"
                />
              </router-link>
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg"
            >
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <router-link
                    tag="div"
                    class="vx-logo cursor-pointer flex items-center lg:hidden"
                    to="/"
                  >
                    <img
                      width="90%"
                      src="@/assets/images/logo/logo.png"
                      alt="login"
                      class="mx-auto"
                    />
                  </router-link>
                  <h4 class="mb-4 hidden lg:block">
                    Create Account
                  </h4>
                  <div>
                    <p>Fill the below form to create a new account.</p>
                  </div>
                  <form @submit.prevent="register" class="mt-2">
                    <div class="my-2">
                      <div class="w-full">Email</div>
                      <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        v-model="registerUser.email"
                        class="w-full"
                        @input="updateField('email')"
                      />
                    </div>
                    <div class="field-error" v-if="isFieldInvalid('email')">
                      Valid Email is required
                    </div>
                    <div class="field-error" v-if="duplicateEmail">
                      {{ duplicateEmail }}
                    </div>
                    <div class="my-2">
                      <div class="w-full">Password</div>
                      <vs-input
                        type="password"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        v-model="registerUser.password"
                        @input="updateField('password')"
                        class="w-full"
                      />
                      <div
                        class="field-error"
                        v-if="isFieldInvalid('password')"
                      >
                        Password is required
                      </div>
                    </div>
                    <div class="my-2">
                      <div class="w-full">Gender</div>
                      <div>
                        <vs-select v-model="registerUser.gender">
                          <vs-select-item key="1" value="male" text="Male" />
                          <vs-select-item
                            key="2"
                            value="female"
                            text="Female"
                          />
                          <vs-select-item key="3" value="na" text="N/A" />
                        </vs-select>
                      </div>
                    </div>

                    <div class="my-2">
                      <div class="w-full">Date of Birth</div>
                      <DatePicker v-model="registerUser.dob" />
                    </div>
                    <div class="flex">
                      <vs-checkbox
                        class="w-24"
                        v-model="registerUser.confirmPolicy"
                        >Confirm</vs-checkbox
                      >
                      <div class="mt-25">
                        <a target="_blank" href="https://ballstar.com/tos"
                          >ToS</a
                        >
                        and
                        <a
                          target="_blank"
                          href="https://ballstar.com/privacy-policy"
                          >Privacy Policy</a
                        >
                      </div>
                    </div>

                    <div class="flex flex-wrap justify-between my-5">
                      <router-link to="forgot-password">
                        Forgot Password?
                      </router-link>
                    </div>
                    <vs-button type="border" to="login">Login</vs-button>
                    <vs-button
                      button="submit"
                      @click.prevent="register"
                      :disabled="$v.$invalid"
                      class="float-right"
                      >Register</vs-button
                    >
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import DatePicker from "vue-flatpickr-component";
const isTrue = val => !!val;
export default {
  components: { DatePicker },
  data() {
    return {
      registerUser: {
        email: "",
        password: "",
        gender: null,
        dob: null,
        confirmPolicy: null
      },
      duplicateEmail: null,
      invalid: false
    };
  },
  validations: {
    registerUser: {
      email: {
        required,
        email
      },
      password: {
        required
      },
      confirmPolicy: {
        required,
        isTrue
      }
    }
  },
  methods: {
    ...mapActions({
      sessionRegister: "session/register",
      profile: "session/profile",
      goToDashboard: "session/goToDashboard"
    }),
    async register() {
      const response = await this.sessionRegister(this.registerUser);
      if (response["error"]) {
        this.duplicateEmail = response["error"]["email"];
      } else {
        await this.profile();
        this.$toasted.success("Successfully Created Account").goAway(2000);
        this.goToDashboard();
      }
    },
    isFieldInvalid(name) {
      return (
        this.$v.registerUser[name].$dirty && this.$v.registerUser[name].$invalid
      );
    },
    updateField(name) {
      console.log("update field", name);
      this.duplicateEmail = false;
      this.$v.registerUser[name].$touch();
    }
  },
  metaInfo() {
    return { title: this.$route.meta.title };
  }
};
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
